import ECardTemplateIcon from '@material-ui/icons/ViewList';

import EduSyncStudentEnrollmentHistoriesList from './EduSyncStudentEnrollmentHistoriesList';

export default {
  list: EduSyncStudentEnrollmentHistoriesList,
  icon: ECardTemplateIcon,
};
